import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./visually-hidden.css?inline";

@customElement("eko-visually-hidden")
export class VisuallyHidden extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-visually-hidden": VisuallyHidden;
  }
}

export default VisuallyHidden;
